<script>
 import Tailwindcss from './Tailwindcss.svelte';
 import MotwHeader from './MotwHeader.svelte';
 import SearchBar from './SearchBar.svelte';
 import NavBar from './NavBar.svelte';
 import LibraryCovers from './LibraryCovers.svelte';
 import LibraryTable from './LibraryTable.svelte';
 import BookModal from './BookModal.svelte';
 import { onMount } from 'svelte';
 import { lasthash } from './store.js';
 import { restapi } from './store.js';
 import { dynamicSort, mockHttpRequest } from './localCalibre.js';

 let t = true;
 let mock = false;
 let bookm = false;
 let books = [];
 let navbarLinks = {"searchStatus": "loading..."};
 let book = getLoadingBook();

 let lochash = [];
 const unsubscribe = lasthash.subscribe(value => {
     lochash = JSON.parse(value);
 });

 function getLoadingBook() {
     return {
         title: "Loading...",
         authors: ["Slow Network", "Mere Boredom", "La-di-dada", "et al."],
         cover_url: "data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
         library_url: "",
         pubdate: "",
         formats: [],
         publisher: "Wait until you're older; wait until the upturn;",
         year: "wait until it stops raining.",
         abstract: "You are called for interview at ten past ten only to find yourself pulling a ticket from a machine that seems designed not for the efficient parcelling of your time, only to tease, to torment. Number one hundred and forty fucking six. The practical method would be to spend such time profitably: be prepared; take a book with you. You know its going to happen because everyday you have lived, you have learned more about the deferral of events. Wait until you're older; wait until the upturn; wait until it stops raining. Whether it's the fear of failure or sheer, stupid obediance that allays the logical and most human desire to lash out at such moments is a mystery to me, but for now I'll offer no alternative. Let time sharpen your anxiety and mould it into a palpable hatred whose very formation is the precipitate of release. Just wait.",
         tags: [],
         librarian: "Amateur"
     };
 }

 function getLoadingBooks() {
     var loadingBook =
         {
             title: "",
             authors: [""],
             library_url: "",
             cover_url: "data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
             librarian: "",
             _id: ""
         }
     return [...Array(12)].map((_, i) => loadingBook)
 }

 function setLastHash(h) {
     lochash[1] = h;
     lasthash.set(JSON.stringify(lochash))
 }

 async function fetchBooks(url) {
     if (books.length === 0) {
         books = getLoadingBooks();
     }
     navbarLinks = {"searchStatus": `loading${".".repeat(Math.floor(Math.random()* (6 - 2) + 2))}`};
     if (mock) {
         var data = mockHttpRequest(CALIBRE_BOOKS1.books, url, 48)
     } else {
         const res = await fetch(url);
         var data = await res.json();
     }
     const m = data._meta
     const status = data._links.self.href.split("/");
     var statusLine = "";
     if (status[0] === "books") {
         statusLine = "all books";
     }
     else {
         statusLine = `${status[1]}: ${decodeURIComponent(status[2])}`.toLowerCase();
     }
     const iLow = m.max_results * (m.page - 1);
     const iHigh = Math.min(m.page * m.max_results, m.total);
     data._links.searchStatus = `${iLow}-${iHigh} of ${m.total} (${statusLine})`;
     navbarLinks = data._links;
     books = data._items;
 };

 async function fetchBook(url) {
     if (url.endsWith("book/")) {
         return getLoadingBook()
     }
     if (lochash[lochash.length -1] == "") {
         navbarLinks = {"searchStatus": ""};
     }
     book = getLoadingBook();

     if (mock) {
         var _ = mockHttpRequest(CALIBRE_BOOKS1.books, url, 48, "books")
     } else {
         const res = await fetch(url);
         var _ = await res.json();
     }

     if (_ === "TRYAGAIN") {
         return
     } else {
         if (_.pubdate.slice(0, 4) !== "0101") {
             _.year = _.pubdate.slice(0, 4)
         }
         book = _;
     };
 }

 function dispatchHash() {
     var lh = location.hash;

     if (!lochash[0] && !lh.startsWith("#/book/")) {
         window.scrollTo(0,0);
     }

     if (lh.endsWith("t=l")) {
         lh = lh.replace("t=l", "")
         t = true;
     }
     bookm = false;
     var url = "";
     if (lh == "" || lh == "#/?") {
         lochash[0] = false;
         url = "books";
     } else if (lh.startsWith("#/book/")) {
         bookm = !bookm;
         fetchBook(`${$restapi }${lh.slice(2)}`);
         return
     } else if (lh.startsWith("#/")) {
         lochash[0] = false;
         url = lh.slice(2);
     }
     setLastHash(lh);
     fetchBooks(`${$restapi }${url}`);
 };

 function nextModal(e) {
     var bid = books.map(b => b._id).indexOf(e.detail)
     if (bid > -1 && bid < books.length-1) {
         location.hash = `#/book/${books[bid+1]._id}`
     } else {
         window.scrollTo(0, document.body.scrollHeight);
         lochash[0] = true;
         lasthash.set(JSON.stringify(lochash))
         location.hash = lochash[lochash.length -1];
     }
 }

 function prevModal(e) {
     var bid = books.map(b => b._id).indexOf(e.detail)
     if (bid > 0) {
         location.hash = `#/book/${books[bid-1]._id}`
     } else {
         location.hash = lochash[lochash.length -1];
         window.scrollTo(0, 0);
     }
 }

 document.onreadystatechange = function() {
     if (document.readyState === 'complete' && !location.hash.endsWith("t=l")) {
         t = false;
     }
 }

 onMount(() => {
     if (CALIBRE_BOOKS1.portable) {
         mock = true;
         [...Array(7).keys()].forEach(function (n) {
             var i = n + 2;
             var e = document.createElement('script');
             e.onload = function () {
                 CALIBRE_BOOKS1.books = [...CALIBRE_BOOKS1.books, ...eval(`CALIBRE_BOOKS${i}`).books];
                 CALIBRE_BOOKS1.books.sort(dynamicSort("-last_modified"));
                 dispatchHash()
             }
             e.src = `static/data${i}.js`;
             document.body.appendChild(e)
         })
     }
     lasthash.set("[\"\",\"\"]");
     dispatchHash()
 }
 )

 $: hashChanged = ()=> dispatchHash();
</script>

<svelte:window on:hashchange={hashChanged} />
<Tailwindcss />
{#if bookm}
    <BookModal bind:bookm={bookm} book={book} on:nextModal={nextModal} on:prevModal={prevModal} />
{/if}
<MotwHeader bind:t={t} mock={mock} />
<SearchBar mock={mock} />
<NavBar navbarLinks={navbarLinks} />
{#if t}
    <LibraryTable books={books} />
{:else}
    <LibraryCovers books={books} />
{/if}
<NavBar navbarLinks={navbarLinks} />
